module.exports = __webpack_public_path__ + "static/media/post2.fd8a5a2f.jpg";